import { format } from 'date-fns';

const DateFormatted = ({ inputDate, dateFormat = 'LLL d, yy' }) => {
	if (!inputDate) return null;

	const dateFormatted = format(new Date(inputDate), dateFormat);
	return <>{dateFormatted}</>;
};
export default DateFormatted;
